module.exports = __webpack_public_path__ + "img/join_xrobot@2x.57ff9884.png";